import { WandSparkles } from 'lucide-react';

const inputCls =
  'w-24 rounded-lg border border-neutral-300 bg-white px-2 py-1 text-xs tabular-nums outline-none focus:ring-1 focus:ring-blue-400 dark:border-neutral-600 dark:bg-neutral-700 dark:text-neutral-100';

export default function BulkActionsBar({
  selectedCount,
  bulkQuantity,
  onChangeBulkQuantity,
  onApplyBulk,
  onClearSelection,
}) {
  if (!selectedCount) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl border border-blue-200 bg-blue-50 px-3 py-2.5 text-xs dark:border-blue-800 dark:bg-blue-950/50">
      <span className="font-semibold text-blue-900 dark:text-blue-100">{selectedCount} selected</span>
      <span className="text-blue-600 dark:text-blue-300">Bulk quantity</span>
      <input
        type="number"
        min="1"
        aria-label="Bulk quantity"
        value={bulkQuantity}
        onChange={(e) => onChangeBulkQuantity(e.target.value)}
        className={inputCls}
        placeholder="Qty"
      />
      <button
        type="button"
        onClick={onApplyBulk}
        className="business-primary-action inline-flex items-center gap-1 rounded-lg bg-blue-600 px-2.5 py-1 font-medium text-white hover:bg-blue-700"
      >
        <WandSparkles className="h-3.5 w-3.5" /> Apply
      </button>
      <button
        type="button"
        onClick={onClearSelection}
        className="rounded-lg border border-blue-300 bg-white px-2.5 py-1 font-medium text-blue-700 hover:bg-blue-100 dark:border-blue-700 dark:bg-blue-950 dark:text-blue-200 dark:hover:bg-blue-900"
      >
        Clear
      </button>
    </div>
  );
}
